module.exports = __webpack_public_path__ + "img/aero-shot-2.dd20ae3a.webp";